module.exports = __webpack_public_path__ + "images/emoji/department_store.74f20f7d52e2d53f9131.png";